import { createContext, useContext } from 'react';
export const ContentAreaContext = /*#__PURE__*/createContext({
  isRangeKnown: false,
  range: null
});
export const useContentArea = () => useContext(ContentAreaContext);
//# sourceMappingURL=content-area-context.js.map